import React, { StrictMode } from "react";

//import { Helmet } from "react-helmet";
import { HashRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

//import { useAccuCustomization } from "../../hooks/useAccuCustomization";
import { DEFAULT_STALE_TIME } from "../../queries/constants"; //"./queries/constants";
import { Application } from "../Application";
import { TranslationsServiceProvider } from "../../providers/TranslationsServiceProvider";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: DEFAULT_STALE_TIME
        }
    }
});

export const ApplicationContainer = () => {
    // TBD
    //   const accuCustomization = useAccuCustomization();
    //   if (!accuCustomization) return <React.Fragment></React.Fragment>;
    return (
        <StrictMode>
            {/*   {accuCustomization ? (
                <Helmet>
                    <link
                        rel="apple-touch-icon"
                        href={__styleEnv__ + `${accuCustomization?.mobileIcons?.default}`}
                    />
                    <link
                        rel="apple-touch-icon"
                        sizes="58x58"
                        href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon58x58}`}
                    />
                    <link
                        rel="apple-touch-icon"
                        sizes="76x76"
                        href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon76x76}`}
                    />
                    <link
                        rel="apple-touch-icon"
                        sizes="152x152"
                        href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon152x152}`}
                    />
                    <link
                        rel="apple-touch-icon"
                        sizes="167x167"
                        href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon167x167}`}
                    />
                    <link
                        rel="apple-touch-icon"
                        sizes="180x180"
                        href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon180x180}`}
                    />
                    <link
                        rel="icon"
                        sizes="128x128"
                        href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon128x128}`}
                    />
                    <link
                        rel="icon"
                        sizes="192x192"
                        href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon192x192}`}
                    />
                </Helmet>
            ) : null} */}
            <Router>
                <QueryClientProvider client={queryClient}>
                    <TranslationsServiceProvider>
                        <Application />
                    </TranslationsServiceProvider>
                </QueryClientProvider>
            </Router>
        </StrictMode>
    );
};
